<div class="tw-relative tw-overflow-scroll tw-h-full">
  @if (!loading) {
    <div class="tw-font-body tw-bg-teal-200 tw-pt-4">
      <!-- Back Button -->
      @if (!isTimerPage) {
        <div class="tw-flex tw-absolute tw-top-2 tw-w-[40px] tw-h-[40px] tw-p-2 tw-justify-center tw-items-center tw-shrink-0 tw-rounded-xl tw-bg-black tw-shadow-[0_2px_4px_0_rgba(0,0,0,0.10)] tw-mt-4 tw-ml-4 tw-z-10"
             (click)="back()">
          <cs-icon class="tw-h-6 tw-w-6 tw-text-white" [iconName]="'arrow_back'"></cs-icon>
        </div>
      }
      <!-- Header -->
      <div class="tw-w-[90%] tw-mx-auto tw-flex tw-items-stretch tw-gap-5 tw-pb-11">
        <div class="tw-flex-1 tw-pt-[78px]">
          @if (isEnglishUser) {
            @if (isHairReport) {
              <p class="tw-font-lexend tw-font-bold tw-text-[28px] tw-leading-[29px] tw-text-black tw-capitalize">{{userFirstName}}'s <br /> <span class="tw-inline-block tw-mt-1"> Hair Report </span></p>
            } @else {
              <p class="tw-font-lexend tw-font-bold tw-text-[28px] tw-leading-[29px] tw-text-black tw-capitalize">{{userFirstName}}'s <br /> <span class="tw-inline-block tw-mt-1"> Skin Report </span></p>
            }
          } @else {
            @if (isHairReport) {
              <p class="tw-font-lexend tw-font-bold tw-text-[28px] tw-leading-[29px] tw-text-black tw-capitalize" i18n="@@usernameHairReport">{{userFirstName}} <br /> <span class="tw-inline-block tw-mt-1"> Hair Report </span></p>
            } @else {
              <p class="tw-font-lexend tw-font-bold tw-text-[28px] tw-leading-[29px] tw-text-black tw-capitalize" i18n="@@usernameSkinReport">{{userFirstName}} <br /> <span class="tw-inline-block tw-mt-1"> Skin Report </span></p>
            }
          }
          <div class="tw-opacity-10 tw-border tw-border-solid tw-border-black tw-mt-[14px]"></div>
          <div class="tw-font-bold tw-text-100 tw-mt-[9px] tw-mb-[14px]">
            @if (isHairReport) {
              <p class="tw-text-orange-400 tw-uppercase" i18n="@@yourHairSpecialist"> Your hair specialist </p>
            } @else {
              <p class="tw-text-orange-400 tw-uppercase" i18n="@@yourSkinSpecialist"> Your skin specialist </p>
            }
            <p class="tw-text-black">{{allocatedDoctor?.DoctorDisplayName}}</p>
          </div>
        </div>
        <div class="tw-flex-1 tw-max-w-[42%] tw-flex tw-items-end">
          <img class="tw-object-contain tw-w-full tw-h-auto" [src]="allocatedDoctor?.DoctorImageThumbnail" alt="doctor" />
        </div>
      </div>
      <div class="font-noto tw-rounded-3xl tw-bg-gray-80">
        <section class="tw-bg-gray-80 tw-w-full tw-rounded-tl-5 tw-rounded-tr-5">
          <div appTrackScrollDepth="report_concern_card" class="tw-w-[90%] tw-mx-auto tw-pt-5 tw-pb-4 tw-shadow-z4 tw-rounded-[10px] tw-relative -tw-top-11 tw-font-lexend tw-bg-white">
            <div class="tw-mx-4">
              <ng-container *ngTemplateOutlet="concernsTemplate"></ng-container>
            </div>
          </div>
          @if (showAiDetectionCheckups) {
            <section class="tw-mb-6 -tw-mt-5 tw-mx-4">
              <div class="tw-flex tw-flex-wrap tw-gap-2">
                @for (checkup of aiDetectionCheckups; track checkup.objectId) {
                  <app-ai-detection-canvas
                    class="tw-block tw-h-36"
                    [class]="aiDetectionCanvasWidthClass"
                    [instantCheckup]="checkup"></app-ai-detection-canvas>
                }
              </div>
            </section>
            @if(overallSummary) {
              <div class="tw-mx-4 -tw-mt-2 tw-mb-6">
                <div [ngClass]="brandFontClass" class="tw-text-300 tw-text-gray-800 tw-font-bold tw-uppercase" i18n="@@analysisSummary">Analysis Summary</div>
                <div class="tw-text-300 tw-text-gray-500">
                  {{ overallSummary }}
                </div>
              </div>
            }
          } @else {
            <div appTrackScrollDepth="overall_summary" class="tw-flex tw-justify-space-around tw-gap-4 tw-items-start tw-mx-4 -tw-mt-4 tw-mb-6">
              @if (previousInstantCheckup?.[0]?.['imagePath']) {
                <img class="w40 tw-object-contain tw-h-50" [src]="previousInstantCheckup[0]['imagePath']" />
              }
              @if(overallSummary) {
                <div>
                  <div [ngClass]="brandFontClass" class="tw-text-300 tw-text-gray-800 tw-font-bold tw-uppercase" i18n="@@reportOverallSummaryLabel">Overall Summary</div>
                  <div class="tw-text-300 tw-text-gray-500">
                    {{ overallSummary }}
                  </div>
                </div>
              }
            </div>
          }
          <rebranded-report-parameter appTrackScrollDepth="report_parameters" [skinParametersInfo]="skinParametersInfo" [isHairReport]="isHairReport"></rebranded-report-parameter>
          @if (drVideoExpAssets) {
            <section class="tw-mb-4" appTrackScrollDepth="doctor_video">
              <h1 class="tw-font-body tw-font-bold tw-text-500 tw-text-gray-800 tw-ml-4 tw-mb-3"
                  i18n="@@whatYouCanExpect">What you can expect</h1>
              <div class="tw-flex tw-gap-2 tw-items-center tw-overflow-y-auto tw-pl-4">
                @for (video of drVideoExpAssets.video; track $index) {
                  <div class="tw-w-2/5 tw-shrink-0">
                    <app-floating-video-panel [url]="video"></app-floating-video-panel>
                  </div>
                }
                @for (image of drVideoExpAssets.images; track $index) {
                  <div class="tw-w-2/5 tw-shrink-0 tw-overflow-hidden">
                    <img class="tw-object-cover tw-h-full tw-w-full tw-object-center"
                         [src]="image"
                         alt="report" />
                  </div>
                }
              </div>
            </section>
          }
          @if (showRootCausesBanner) {
            <app-root-cause-banner appTrackScrollDepth="root_cause" [rootCauses]="rootCauses" [changeHeading]="showArrowUIRootCauses"></app-root-cause-banner>
          }
          <!-- Treatment Plan -->
          @if (showTreatmentPlan) {
            <app-report-treatment-plan
              appTrackScrollDepth="report_treatment_plan"
              [showArrowUI]="showRootCausesBanner && showArrowUIRootCauses"
              [displayConcern]="resolvedConcernName"
              [languagePreference]="user?.get('languagePreference')"
              [allocatedDoctorImage]="allocatedDoctor?.doctorDisplayImage"
              [regimen]="regimen"
              [experiment]="experimentService.treatmentPlanDescriptionExperiment?.variant">
            </app-report-treatment-plan>
          }

          <app-improvement-timeline [placement]="ImprovementTimelinePlacement.REPORT" [regimenClass]="regimen?.class"></app-improvement-timeline>

          <!-- Hero Ingredients / Improvement Journey -->
          @if (showHeroIngredients && (!showTreatmentPlan || experimentService.treatmentPlanDescriptionExperiment?.variant?.showHeroIngredients)) {
            <hero-ingredients appTrackScrollDepth="hero_ingredients"
                              [heroIngredients]="heroIngredients"
                              [doctorDisplayImage]="allocatedDoctor?.doctorDisplayImage"
                              [isRebrandedHeroIngredients]="isRebrandedHeroIngredients"
                              [isHairReport]="isHairReport"></hero-ingredients>
          } @else if (!showTreatmentPlan && !showHeroIngredients) {
            <improvement-journey appTrackScrollDepth="improvement_journey"
                                 [showFirstJourney]="showFirstJourney"
                                 [doctorDisplayImage]="allocatedDoctor?.doctorDisplayImage"></improvement-journey>
          }
        </section>
        <testimonial-wall appTrackScrollDepth="testimonial" [regimen]="regimen"></testimonial-wall>
        <div appTrackScrollDepth="report_footer" class="tw-bg-white tw-ml-auto tw-mr-auto tw-px-4 tw-pb-10 tw-pt-6">
          <div class="tw-text-200 tw-text-gray-800">
            1. Dermatologists at Cure follow the American Association of Dermatology,
            European association of Dermatology and IADVL guidelines to ensure the
            best and latest practices are adopted for identifying and treating your
            skin problems.
          </div>
          <div class="tw-text-200 tw-mt-2 tw-text-gray-800">
            2. Active ingredients in prescription products are supported by
            clinical trial evidence and have secured FDA approval.
          </div>
          <div class="tw-flex tw-flex-col tw-mt-8 tw-justify-center">
            <img class="tw-w-[150px]"
                 src="https://cdn.cureskin.com/app/img/dr-charu-sign.png"
                 alt="doctor" />
            <div class="tw-text-200 tw-text-gray-800">Head of Dermatology</div>
          </div>
          <div class="tw-border-b tw-border-gray-300 tw-mt-8 tw-mb-2"></div>
          <div class="tw-flex tw-justify-between"
               [style.paddingBottom]="showRegimenToast ? '80px' : '0'">
            <div class="tw-text-100 tw-uppercase tw-pb-5 tw-text-gray-800">End of report</div>
            <cs-icon class="tw-w-[38px] tw-h-[12px]"
                     [iconName]="'cs-logo'"></cs-icon>
          </div>
        </div>
      </div>
    </div>
  }
  <ng-template #concernsTemplate>
    <p class="tw-pb-1 tw-text-300 tw-text-gray-800 tw-font-medium">
      @if (isHairReport) {
        <span class="tw-font-normal" i18n="@@reportPrimaryConcernLabel">Primary concern:</span>
      } @else {
        <span class="tw-font-normal" i18n="@@reportMainConcernLabel">Main concern:</span>
      }
      <span class="tw-font-bold tw-inline-block first-letter:tw-uppercase">&nbsp;{{ resolvedConcernName }}</span>
    </p>
    @if (otherConcerns.length > 0) {
      <p class="tw-pb-1 tw-text-300 tw-text-gray-800 tw-font-medium">
        @if (isHairReport) {
          <span class="tw-font-normal" i18n="@@reportSecondaryConcernLabel">Secondary concern: <span class="bolder"> {{ otherConcerns }}</span></span>
        } @else {
          <span class="tw-font-normal" i18n="@@reportOtherConcernsLabel">Other concerns: <span class="bolder"> {{ otherConcerns }}</span></span>
        }
      </p>
    }
    <p class="tw-pb-1 tw-text-300 tw-text-gray-800 tw-font-medium">
      <span class="tw-font-normal">
        <span i18n="@@reportSeverityLabel">Severity:</span>
        <span class="bolder">&nbsp;</span>
        <span class="bolder">{{severity}}</span>
      </span>
    </p>
  </ng-template>
</div>
